import {DragDropModule} from '@angular/cdk/drag-drop';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NbCheckboxModule, NbInputModule, NbSpinnerModule, NbToggleModule} from '@nebular/theme';
import {SortPipe} from 'compob2b-libs';
import {BaseComponent, HeaderComponent} from 'compob2b-table';
import {NgxPaginationModule} from 'ngx-pagination';
import {GlobalSearchPipe} from '../../pipes/global-search-pipe';
import {RenderPipe} from '../../pipes/render-pipe';
import {SearchPipe} from '../../pipes/search-pipe';
import {PaginationComponent} from '../pagination/pagination.component';
import {TableTHeadComponent} from '../thead/thead.component';
import {TuiIcon} from '@taiga-ui/core'

@NgModule({
  declarations: [
    BaseComponent,
    PaginationComponent,
    TableTHeadComponent,
    SearchPipe,
    RenderPipe,
    GlobalSearchPipe,
  ],
  imports: [CommonModule, NgxPaginationModule, DragDropModule, ScrollingModule, NbCheckboxModule, NbToggleModule, NbInputModule, SortPipe, NbSpinnerModule, TuiIcon, HeaderComponent],
  exports: [BaseComponent, PaginationComponent, RenderPipe],
})
export class BaseModule {
}
